<script lang="ts">
	import type { Snippet } from "svelte";
	import { cn } from "#lib/web-ui/ui/utils.js";
	import FooterCopyright from "./footer-copyright.svelte";
	import InvestmentDisclaimer from "./investment-disclaimer.svelte";

	let {
		entityName,
		disclaimer = false,
		class: className,
		children
	}: {
		entityName: string;
		disclaimer?: boolean;
		class?: string;
		children: Snippet;
	} = $props();
</script>

<footer class={cn("bg-foreground text-background flex w-full flex-col", className)}>
	{@render children()}
	<FooterCopyright {entityName} />
	{#if disclaimer}
		<InvestmentDisclaimer {entityName} />
	{/if}
</footer>
